export const WEBVIEW_RESOURCE_VERSION = '20260616_01';

export const getVersionUrl = (url?: string) => {
  if (!url) return '';
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${WEBVIEW_RESOURCE_VERSION}`;
};
